import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/loan-calculator/page.tsx")